module.exports = __webpack_public_path__ + "img/py.bbc22e41.svg";